export const generateLetterMarker = (
   letter = 'A',
   bgColor = 'AC0101',
   fgColor = 'FFFFFF'
) => {
   return `https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${letter}|${bgColor}|${fgColor}`;
};
export const generateLetterMarkerWithSize = (
   letter = 'A',
   bgColor = 'AC0101',
   markerSize = 0.8,
   letterSize = 12
) => {
   return `https://chart.googleapis.com/chart?chst=d_map_spin&chld=${markerSize}|0|${bgColor}|${letterSize}|b|${letter}`;
};

export const stopMarker = (
   stopNo = 'A',
   bgColor = 'AC0101',
   fgColor = "FFFFFF",
   letterSize = 8
) => {
   return  `https://ui-avatars.com/api/?name=${stopNo}&background=${bgColor}&color=${fgColor}&size=${letterSize}&bold=true`
   //return `https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${stopNo}|${bgColor}|${fgColor}|${letterSize}`
   // //`https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${stopNo}|${bgColor}|${fgColor}|8`
};

/**
 * Creates a default USA bounds object
 * @returns {Object} - Google Maps LatLngBounds object for USA
 */
export const getDefaultUSABounds = () => {
  if (!window.google) {
    console.warn('Google Maps not available');
    return null;
  }
  
  return new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(25.0, -125.0), // Southwest corner of USA
    new window.google.maps.LatLng(49.0, -66.0)   // Northeast corner of USA
  );
};

/**
 * Safely fits bounds on a map, handling single-point bounds
 * @param {Object} map - Google Maps instance
 * @param {Object} bounds - LatLngBounds object
 * @param {number} defaultZoom - Zoom level to use for single points (default: 15)
 * @returns {Object} - Center LatLng object or null
 */
export const safeFitBounds = (map, bounds, defaultZoom = 15) => {
  // Validate inputs
  if (!map) {
    console.warn('safeFitBounds: map is null or undefined');
    return null;
  }
  
  if (!bounds) {
    console.warn('safeFitBounds: bounds is null or undefined');
    return null;
  }
  
  if (typeof bounds.isEmpty !== 'function' || bounds.isEmpty()) {
    console.warn('safeFitBounds: bounds is empty or invalid');
    return null;
  }
  
  // Check if map has required methods (validate it's a Google Maps instance)
  if (typeof map.setCenter !== 'function' || typeof map.fitBounds !== 'function') {
    console.error('safeFitBounds: map object does not have required methods (setCenter, fitBounds)', map);
    return null;
  }
  
  try {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const isSinglePoint = (ne.lat() === sw.lat() && ne.lng() === sw.lng());
    
    if (isSinglePoint) {
      // Single point - set center and zoom instead of fitBounds
      map.setCenter(ne);
      if (typeof map.setZoom === 'function') {
        map.setZoom(defaultZoom);
      }
      return ne;
    } else {
      // Multiple points - use fitBounds
      map.fitBounds(bounds);
      return bounds.getCenter();
    }
  } catch (error) {
    console.error('safeFitBounds: Error fitting bounds', error);
    return null;
  }
};

